import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { selectLoadedCurrentUser, UserGroupNames } from 'pl-core-services';
import { PL_ROUTING } from '@common/constant';

@Component({
  selector: 'pl-root',
  templateUrl: './pl-root.component.html',
  styleUrls: ['./pl-root.component.scss'],
})
export class PlRootComponent implements OnInit {
  constructor(private router: Router, private store: Store) {}

  ngOnInit(): void {
    firstValueFrom(this.store.pipe(selectLoadedCurrentUser)).then(
      async (user) => {
        if (!user || !user.groups) {
          return;
        }

        if (user.groups.includes(UserGroupNames.SAAS_PROVIDER)) {
          await this.router.navigateByUrl(PL_ROUTING.LANDING_HOME);
        } else if (user.groups.includes(UserGroupNames.SCHOOL_STAFF_ADMINS)) {
          await this.router.navigateByUrl(PL_ROUTING.USER_MANAGEMENT);
        }
      }
    );
  }
}
